import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { doLogin } from '../../services/AuthService';

function Login() {
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (error) {
      console.log({ error });
    }
  }, [error]);

  function togglePasswordVisibility() {
    setPasswordVisible(!passwordVisible);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    await doLogin(username, password)
      .then((response) => {
        if (response) {
          localStorage.setItem('hasFutures', response.hasFutures);
          localStorage.setItem('id', response.id);
          navigate('/settings');
        }
      })
      .catch((err) => {
        console.log(err);
        setError(err.response?.data || 'An error occurred');
      });
  }

  return (
    <React.Fragment>
      <main>
        <div className="auth-page-content d-flex align-items-center justify-content-center vh-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8 col-lg-6 col-xl-5">
                <div className="card mt-4">
                  <div className="card-body p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">Welcome Back !</h5>
                      <p className="text-muted">Sign in to continue.</p>
                    </div>
                    <div className="p-2 mt-4">
                      <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                          <label htmlFor="username" className="form-label">
                            Username
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="username"
                            placeholder="Enter username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                          />
                        </div>
                        <div className="mb-3">
                          {/* TO DO - Implementar recuperação de senha
                                                        <div className="float-end">
                                                            <a href="auth-pass-reset-basic.html" className="text-muted">Forgot password?</a>
                                                        </div> */}
                          <label
                            className="form-label"
                            htmlFor="password-input"
                          >
                            Password
                          </label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <input
                              type={passwordVisible ? 'text' : 'password'}
                              className="form-control pe-5 password-input"
                              placeholder="Enter password"
                              id="password-input"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              required
                            />
                            <button
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted shadow-none password-addon"
                              type="button"
                              id="password-addon"
                              onClick={togglePasswordVisibility}
                            >
                              <i
                                className={
                                  passwordVisible
                                    ? 'ri-eye-off-fill align-middle'
                                    : 'ri-eye-fill align-middle'
                                }
                              ></i>
                            </button>
                          </div>
                        </div>
                        {error && (
                          <div className="alert alert-danger">{error}</div>
                        )}
                        {/* TO DO - Implementar o botão de remember me
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" value="" id="auth-remember-check"/>
                                                        <label className="form-check-label" htmlFor="auth-remember-check">Remember me</label>
                                                    </div>*/}
                        <div className="mt-4">
                          <button
                            className="btn btn-success w-100"
                            type="submit"
                          >
                            Sign In
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                {/* TO DO - Implementar cadastro de novo usuário
                                    <div className="mt-4 text-center">
                                        <p className="mb-0">Don't have an account ? <a href="auth-signup-basic.html" className="fw-semibold text-primary text-decoration-underline"> Signup </a> </p>
                                    </div>*/}
              </div>
            </div>
          </div>
        </div>
      </main>
    </React.Fragment>
  );
}

export default Login;
